module.exports = __webpack_public_path__ + "img/travolta.73ae74f4.gif";